"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MqttSensorQueue = void 0;
var mqtt = __importStar(require("mqtt"));
var ConversationQueueType_1 = require("./ConversationQueueType");
var MqttSensorQueue = /** @class */ (function () {
    function MqttSensorQueue(options) {
        var _this = this;
        this.subscriptions = new Map();
        this.connect = function () { return mqtt.connect(_this.options.host, _this.options); };
        this.subscribeConvContext = function (header, callback) { return _this.subscribe(ConversationQueueType_1.ConversationQueueType.CONTEXT, header, callback); };
        this.subscribeConvNotification = function (header, callback) { return _this.subscribe(ConversationQueueType_1.ConversationQueueType.NOTIFICATION, header, callback); };
        this.subscribeConvInteraction = function (header, callback) { return _this.subscribe(ConversationQueueType_1.ConversationQueueType.INTERACTION, header, callback); };
        this.subscribeConvLogging = function (header, callback) { return _this.subscribe(ConversationQueueType_1.ConversationQueueType.LOGGING, header, callback); };
        this.callback = function (topic, payload) {
            if (_this.subscriptions.get(topic)) {
                var callback = _this.subscriptions.get(topic);
                callback(payload);
                return;
            }
            console.warn('no callback for topic ' + topic, payload);
        };
        this.getTopic = function (type, header) {
            return "gaia/conversation/" + _this.options.deviceInstanceId + "/" + header.channelId + "/" + type.toLowerCase();
        };
        this.options = options;
        this.client = this.connect();
    }
    MqttSensorQueue.prototype.on = function (event, callback) {
        this.client.on(event, callback);
    };
    MqttSensorQueue.prototype.end = function (force, callback) {
        this.client.end(force, callback);
    };
    MqttSensorQueue.prototype.publish = function (conversationQueueType, header, payload, attributes, type) {
        var topic = this.getTopic(conversationQueueType, header);
        console.debug("Sending message to topic " + topic);
        var payloadStr = JSON.stringify({ attributes: attributes, type: type, payload: payload instanceof Array ? payload[0] : payload });
        var userProperties = Object.assign(header, {
            deviceInstanceId: this.options.deviceInstanceId,
            deviceId: this.options.deviceId,
            userId: this.options.userId
        });
        var opts = { properties: { userProperties: this.removeUndefinedValues(userProperties) } };
        this.client.publish(topic, payloadStr, opts, this.mqttCallback(JSON.parse(payloadStr)));
    };
    MqttSensorQueue.prototype.removeUndefinedValues = function (object) {
        return Object.keys(object).filter(function (key) { return object[key] !== undefined; }).reduce(function (acc, key) {
            acc[key] = object[key];
            return acc;
        }, {});
    };
    MqttSensorQueue.prototype.subscribe = function (type, header, callback) {
        var topic = this.getTopic(type, header);
        if (topic in this.subscriptions.keys()) {
            console.warn(topic + " already subscribed");
            return;
        }
        if (callback) {
            console.debug('subscribe to', topic);
            this.client.subscribe(topic, callback);
            this.subscriptions.set(topic, callback);
        }
    };
    MqttSensorQueue.prototype.unsubscribe = function (topic) {
        this.client.unsubscribe(topic);
    };
    MqttSensorQueue.prototype.publishConvInteraction = function (header, interaction) {
        if (this.getTopic(ConversationQueueType_1.ConversationQueueType.INTERACTION, header) in this.subscriptions.keys()) {
            this.subscribeConvInteraction(header, function () {
            });
        }
        this.publish(ConversationQueueType_1.ConversationQueueType.INTERACTION, header, interaction.payload, interaction.attributes, interaction.type);
    };
    MqttSensorQueue.prototype.mqttCallback = function (payload) {
        return function (error, packet) {
            error ?
                console.error('Failed to publish message', error, packet) :
                console.debug('Successfully published message', payload);
        };
    };
    return MqttSensorQueue;
}());
exports.MqttSensorQueue = MqttSensorQueue;
//# sourceMappingURL=MqttSensorQueue.js.map